import React, { useEffect, useState } from "react";
import { Feature } from "ol";
import { useAppContext } from "../../Contexts/AppContext";
import { useRegistrationContext } from "../../Contexts/RegistrationContext";
import { AccordionItem } from "../../Elements/Accordion";
import { DrawType } from "../../Map/enums";
import { DrawingButton } from "./DrawingButton";
import { SketchProps } from "./SketchProps";
import { useDrawingContext } from "../../Contexts/DrawingContext";

const allowedQuantity = 1;

export const DrawProperty = (): JSX.Element => {
    const { identifiedFeatures, setLocateFeature, drawType } = useAppContext();
    const { drawnFeatures } = useRegistrationContext();
    const { addFromSearch, propertyNote, selectedFeature, setSelectedFeature } = useDrawingContext();

    const [editMode, setEditmode] = useState<boolean>(true);
    const [noteFeature, setNoteFeature] = useState<Feature>(
        drawnFeatures.length && drawnFeatures.find((f) => f.get("DRAWTYPE") === DrawType.PolygonProperty)
    );

    useEffect(() => {
        drawnFeatures && setNoteFeature(drawnFeatures.find((f) => f.get("DRAWTYPE") === DrawType.PolygonProperty));
    }, [drawnFeatures]);

    useEffect(() => {
        if (noteFeature) {
            return;
        }
        const clickedPropertyFeature =
            identifiedFeatures &&
            identifiedFeatures.length &&
            identifiedFeatures.find((f) => f && f.get("Zemes vienības kadastra apzīmējums"));

        clickedPropertyFeature && setLocateFeature(clickedPropertyFeature);
        clickedPropertyFeature && addSelected(clickedPropertyFeature);
    }, [identifiedFeatures]);

    useEffect(() => {
        selectedFeature && setEditmode(noteFeature && noteFeature.get("TEMPID") === selectedFeature.get("TEMPID"));
    }, [selectedFeature]);

    useEffect(() => {
        noteFeature && noteFeature.set("MASTERNAME", propertyNote);
        noteFeature && !propertyNote && setSelectedFeature(noteFeature);
    }, [propertyNote, noteFeature]);

    useEffect(() => {
        drawType !== DrawType.PolygonProperty && setLocateFeature(undefined);
    }, [drawType]);

    const addSelected = (clicked: Feature) => {
        addFromSearch(createFeature(clicked));
    };

    const createFeature = (clicked: Feature) => {
        const newFeature = new Feature();
        newFeature.setGeometry(clicked.getGeometry());
        newFeature.setProperties({
            TYPE: 1,
            DRAWTYPE: DrawType.PolygonProperty,
            MASTERID: Number(clicked.get("OBJECTID")),
            CADASTER: clicked.get("Zemes vienības kadastra apzīmējums")
            // MASTERNAME: this is required to fill by user. Will be copied from DESCRIPTION
        });
        return newFeature;
    };

    const onClickToolbar = () => {
        setEditmode(true);
        setSelectedFeature(noteFeature);
    };

    const title = `Īpašums (${noteFeature ? 1 : 0}/${allowedQuantity})`;

    return (
        <AccordionItem
            title={title}
            changeHeight={Date.now()}
            defaultExpanded={noteFeature ? Math.random() : null}
            key="Īpašums"
        >
            <div className="draw-toolbar">
                <DrawingButton
                    iconClass={"icon-geo-select-finger"}
                    type={DrawType.PolygonProperty}
                    disabled={!!noteFeature}
                ></DrawingButton>
            </div>
            {noteFeature ? (
                <>
                    {editMode ? (
                        <SketchProps
                            feature={noteFeature}
                            placeholder={"Īpašuma nosaukums"}
                            required={true}
                            onBlur={() => setEditmode(false)}
                        ></SketchProps>
                    ) : null}
                    <div className="search-toolbar property-toolbar" onClick={onClickToolbar}>
                        <div className="search-toolbar-text">
                            {propertyNote ? <span>{propertyNote + ", "}</span> : null}
                            <span>{"kad.apz. " + noteFeature.get("CADASTER")}</span>
                        </div>
                        <div className="symbol-label" onClick={() => setLocateFeature(noteFeature)}>
                            <span className="icon-geo-zoom-in"></span>
                        </div>
                    </div>
                </>
            ) : null}
        </AccordionItem>
    );
};
